import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';
import { getLayoutById } from '../../../utilities/get-layout-by-id.esm.js';
import { getLayoutType } from '../../../utilities/get-layout-type.esm.js';
import { updateFieldsInLayout } from '../../../utilities/update-fields-in-layout.esm.js';
import { getCommands } from '../../../utilities/get-commands.esm.js';

function rejectInvalidTypes(type) {
  switch (type) {
    case LayoutType.Default:
      throw new Error('Cannot same a default layout');
    case LayoutType.Custom:
      throw new Error('Cannot same a custom layout');
    case LayoutType.Predefined:
      throw new Error('Cannot same a default layout');
    case LayoutType.Saved:
      return;
    default:
      throw new Error('Invalid layout type');
  }
}
function getSaveCallback(displayLayouts, layouts, onChange, onSaveLayout, onDeleteLayout) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var currentDisplayLayout, type, currentLayout, layoutToBeSaved, newLayouts;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          //Validate
          currentDisplayLayout = getSelectedLayout(displayLayouts);
          type = getLayoutType(currentDisplayLayout);
          rejectInvalidTypes(type);

          //Get saved layout
          currentLayout = getLayoutById(layouts, currentDisplayLayout.id);
          layoutToBeSaved = updateFieldsInLayout(currentLayout, currentDisplayLayout.fields || []);
          if (!(layoutToBeSaved !== currentLayout)) {
            _context.next = 10;
            break;
          }
          //Notify a new array of layouts
          newLayouts = layouts.map(function (l) {
            return l === currentLayout ? layoutToBeSaved : l;
          });
          onChange(newLayouts);
          _context.next = 10;
          return getCommands({
            onSaveLayout: onSaveLayout,
            onDeleteLayout: onDeleteLayout
          })(layouts, newLayouts);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
var createSaveCallbackSelector = function createSaveCallbackSelector() {
  return createSelector(function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.layouts;
  }, function (props) {
    return props.onChange;
  }, function (props) {
    return props.onSaveLayout;
  }, function (props) {
    return props.onDeleteLayout;
  }, getSaveCallback);
};

export { createSaveCallbackSelector, getSaveCallback };
//# sourceMappingURL=save-callback-selector.esm.js.map
